
import { DetailPageProductSkuOption } from '@rcm/cart-core/src';
import React, { useCallback } from 'react';

interface Props {
    sku: DetailPageProductSkuOption;
    isSelected: boolean;
    onClick: (sku: DetailPageProductSkuOption) => void;
}

export const SkuButton = ({ sku, isSelected, onClick }: Props) => {
    const handleClick = useCallback(() => { onClick(sku) }, [sku]);
    return <button className={'btn btn-default' + (isSelected ? ' ProductDetailPageTopBlock-option-selector-button-selected' : '')}
        onClick={handleClick}>
        {sku.optionDescription}
    </button>
};